import { render, staticRenderFns } from "./AccountAdd.vue?vue&type=template&id=4155ed51&scoped=true&"
import script from "./AccountAdd.vue?vue&type=script&lang=js&"
export * from "./AccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountAdd.vue?vue&type=style&index=0&id=4155ed51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155ed51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4155ed51')) {
      api.createRecord('4155ed51', component.options)
    } else {
      api.reload('4155ed51', component.options)
    }
    module.hot.accept("./AccountAdd.vue?vue&type=template&id=4155ed51&scoped=true&", function () {
      api.rerender('4155ed51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AccountAdd.vue"
export default component.exports